import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../../lib/api";

export function BlogPreview() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((res) => setPosts(res.data.slice(0, 3))).catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;

  return (
    <section className="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="blog-preview-section">
      <div className="flex items-end justify-between mb-10">
        <div>
          <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">Field Notes</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-2">Engineering Insights</h2>
        </div>
        <Link to="/blog" className="hidden sm:inline-flex text-sm font-mono uppercase text-zinc-400 hover:text-amber-light" data-testid="blog-preview-view-all-link">
          All Articles
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map((post, i) => (
          <motion.div
            key={post.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <Link to={`/blog/${post.slug}`} data-testid={`blog-preview-card-${post.slug}`} className="group block">
              <div className="aspect-[16/10] overflow-hidden rounded-md border border-amber-500/10 mb-4">
                <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <span className="text-xs font-mono uppercase tracking-widest text-amber-light">{post.category}</span>
              <h3 className="text-lg font-bold text-white mt-2 leading-snug group-hover:text-amber-light transition-colors">{post.title}</h3>
              <div className="flex items-center gap-1 text-xs text-zinc-500 mt-3">
                {post.read_time} <ArrowUpRight className="h-3 w-3" />
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
